
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M85.5 40.6H121v-.2L87.6 7H43v33.6zM41.8 87.7H7.1L40.4 121h44.9V87.7zM40.6 45.3V7h-.2L7 40.4v44.9h33.6zM87.7 86.3h.1v34.5L121 87.6V43H87.7z"}})])
          )
        }
      }
    